<template>
  <van-popup v-model="show" @closed="close">
    <img
      class="contact-img"
      :src="src || 'https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-04-19/3df50a24e56b0ac8024d8ab92bedef34.png'"
      alt=""
    />
  </van-popup>
</template>

<script>
export default {
  props: ["visible", 'src'],
  watch:{
    visible(val) {
      this.show = val
    }
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    close() {
      this.$emit('hideVisible')
    }
  }
};
</script>

<style lang="scss" scoped>
// @function rem($px) {
//   @return $px / 75 + rem;
// }
.contact-img {
  width: 300px;
  height: 435px;
}
</style>



// WEBPACK FOOTER //
// src/components/contactImg.vue